/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StreakInvitationResponse } from './StreakInvitationResponse';
import {
    StreakInvitationResponseFromJSON,
    StreakInvitationResponseFromJSONTyped,
    StreakInvitationResponseToJSON,
    StreakInvitationResponseToJSONTyped,
} from './StreakInvitationResponse';

/**
 * 
 * @export
 * @interface SharedStreakInvitationListResponse
 */
export interface SharedStreakInvitationListResponse {
    /**
     * 
     * @type {Array<StreakInvitationResponse>}
     * @memberof SharedStreakInvitationListResponse
     */
    invitations: Array<StreakInvitationResponse>;
}

/**
 * Check if a given object implements the SharedStreakInvitationListResponse interface.
 */
export function instanceOfSharedStreakInvitationListResponse(value: object): value is SharedStreakInvitationListResponse {
    if (!('invitations' in value) || value['invitations'] === undefined) return false;
    return true;
}

export function SharedStreakInvitationListResponseFromJSON(json: any): SharedStreakInvitationListResponse {
    return SharedStreakInvitationListResponseFromJSONTyped(json, false);
}

export function SharedStreakInvitationListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedStreakInvitationListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'invitations': ((json['invitations'] as Array<any>).map(StreakInvitationResponseFromJSON)),
    };
}

export function SharedStreakInvitationListResponseToJSON(json: any): SharedStreakInvitationListResponse {
    return SharedStreakInvitationListResponseToJSONTyped(json, false);
}

export function SharedStreakInvitationListResponseToJSONTyped(value?: SharedStreakInvitationListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invitations': ((value['invitations'] as Array<any>).map(StreakInvitationResponseToJSON)),
    };
}

